module.exports = __webpack_public_path__ + "static/gifAddictGif-5e88537a521f6f2a47b8766a92615693.gif";